import type { IconDefinition } from "@fortawesome/fontawesome-common-types"
import {
  faCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons"
import { Typography } from "@mui/material"
import { FaIcon } from "@skistarab/mui-theme"

type Severity = "error" | "warning" | "info" | "success"

type StyledHelperTextProps = {
  helperText: string
  severity: Severity
}

const severityConfig: Record<
  Severity,
  {
    icon: IconDefinition
    color: string
  }
> = {
  error: { icon: faCircleExclamation, color: "error.main" },
  warning: { icon: faTriangleExclamation, color: "warning.main" },
  info: { icon: faCircleInfo, color: "info.main" },
  success: { icon: faCheck, color: "success.main" },
}

const StyledHelperText = ({ helperText, severity }: StyledHelperTextProps) => {
  const { icon, color } = severityConfig[severity]

  const isUrgent = severity === "error" || severity === "warning"

  return (
    <Typography
      variant="caption"
      color="secondary"
      fontSize={14}
      component="span"
      sx={{ display: "inline-flex", alignItems: "flex-start", gap: "8px" }}
      role={isUrgent ? "alert" : "status"}
    >
      <FaIcon
        icon={icon}
        data-testid={`${severity}-icon`}
        aria-hidden="true"
        sx={{ color, fontSize: 16, mt: "4px" }}
      />
      {helperText}
    </Typography>
  )
}

export default StyledHelperText
